import CountUp from "react-countup";
import { cartwhite, erroricon } from "assets/icons/index";
import { more, moreRotated } from "assets/icons/index";
import { useNavigate } from "react-router-dom";
import { HUMAN_PROJECT_DETAILS_PATH } from "Routes/paths";
import { useDispatch, useSelector } from "react-redux";
import { ADD_TO_CART } from "redux/types";
import { useTranslation } from "react-i18next";
import { smsDonationActions } from "redux/actions/SMS Donation/smsDonationActions";
import { userAddCartItemsActions } from "redux/actions/Cart/userAddCartItemsActions";
import { RootState } from "redux/rootReducer";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";
import { notification } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import { requestSecureUrlActions } from "redux/actions/RequestSecureUrl/requestSecureUrlActions";
import ProgressBar from "components/ProgressBar";

interface HumanitarianCasesCardProps {
  data?: any;
  showSmsDonation: boolean;
  setShowSmsDonation: React.Dispatch<React.SetStateAction<boolean>>;
}

interface amountType {
  amount: string;
}

const HumanitarianCasesCard = ({
  data,
  showSmsDonation,
  setShowSmsDonation,
}: HumanitarianCasesCardProps) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { userId, loginData } = useSelector(
    (state: RootState) => state.loginReducer
  );

  const progressBarValue = Math.floor(
    (data?.raised_amount / data?.amount) * 100
  );

  // console.log(data);

  // validating the donation amount
  const formik = useFormik({
    initialValues: {
      amount: "",
    },

    validationSchema: yup.object({
      amount: yup
        .number()
        .typeError(`${t("Amount must be a number")}`)
        .positive(`${t("Amount must be greater than zero")}`)
        .required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: amountType) => {
      dispatch(
        requestSecureUrlActions(
          i18n.language,
          userId ? userId : 0,
          {
            device_info: null,
            projects: {
              humanitarian_projects: [
                {
                  id: data?.id,
                  amount: values.amount,
                },
              ],
            },
          },
          (urlLink: any) => {
            setTimeout(() => {
              window.open(`${urlLink?.message}`, "_blank");
              // dispatch({ type: "SET_SecureUrlData" });
            }, 1000);
          }
        )
      );
    },
  });

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="900"
      className="h-full max-w-[300px] lg:max-w-[400px] p-[8px] shadow-shadow_main hover:shadow-shadow_hover duration-300 rounded-[15px] bg-first_color/15 "
    >
      {/* image section  */}
      <div className="w-full h-[148px] lg:h-[240px] ">
        <img
          className="w-full h-[148px] lg:h-[240px] rounded-[20px]"
          src={data?.thumbnail_url}
          alt=""
        />
      </div>

      {/* progress bar */}
      <div className="mt-[10px] flex flex-col gap-2">
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[16px] text-second_color line-clamp-1 text-ellipsis`}
        >
          {i18n.language === "en" ? data?.title_en : data?.title_ar}
        </p>

        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[400] text-[12px] tex-[#444444] line-clamp-2 text-ellipsis`}
          dangerouslySetInnerHTML={{
            __html: `${
              i18n.language === "en"
                ? data?.description_en
                : data?.description_ar
            }`,
          }}
        ></p>
        <div>
          <ProgressBar value={progressBarValue} />
        </div>
      </div>

      {/* amount section  */}
      <div className="my-[16px]">
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[16px] text-first_color`}
        >
          {t("Donation starts from:")} 1 {t("AED")}
        </p>
        <p
          className={`font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[24px] text-first_color`}
        >
          {" "}
          <CountUp start={0} end={data?.raised_amount} duration={2} />{" "}
          {t("AED")}{" "}
          <span
            className={`font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[400] text-[16px] text-second_color`}
          >
            {" "}
            /<CountUp start={0} end={data?.amount} duration={2} /> {t("AED")}
          </span>
        </p>
      </div>

      {/* inputs section */}
      <div className="w-full flex flex-col gap-4">
        {/* first section  */}
        <div className="w-full">
          <form
            onSubmit={formik.handleSubmit}
            className="w-full flex flex-col gap-2"
          >
            <div className="w-full flex items-center gap-2">
              <input
                type="number"
                name="amount"
                onChange={formik.handleChange}
                placeholder={`${t("Donation amount")}`}
                className={`w-full h-[48px] border-[#D3D3D3] border-[1px] rounded-[10px]  placeholder:${
                  i18n.language === "en"
                    ? "font-Poppins pl-[10px]"
                    : "font-Almarai pr-[10px]"
                } font-[600] placeholder:text-[13px] focus:outline-none pb-[8px]`}
              />
              <button
                className={`h-[48px] w-[120px] flex items-center justify-center bg-[#B07F4A] text-[#ffffff] text-[15px] font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] rounded-[15px] hover:bg-[#614629] duration-300`}
              >
                {t("Donate")}
              </button>
            </div>
            {formik.errors.amount && (
              <p
                className={`mt-[5px] font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
              >
                <img className="max-w-[18px]" src={erroricon} alt="" />
                {formik.errors.amount}
              </p>
            )}
          </form>
        </div>
        {/* second section  */}
        <div className="w-full flex items-center gap-2">
          {/* sms donation  */}
          <button
            onClick={() => {
              setShowSmsDonation(!showSmsDonation);
              dispatch(
                smsDonationActions({
                  id: data?.id,
                  donation_type: "helping_case",
                })
              );
            }}
            className={`h-[48px] w-full flex items-center justify-center bg-[#E9EBEC] text-[#263A4B] text-[15px] font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] rounded-[15px] hover:bg-[#e4cdb4] duration-300`}
          >
            {t("SMS Donation")}
          </button>

          {/* cart button  */}
          <button
            className={`h-[48px] w-[120px] flex items-center justify-center bg-[#B07F4A] text-[#ffffff] text-[15px] font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] rounded-[15px] hover:bg-[#614629] duration-300`}
            onClick={() => {
              if (formik.values.amount) {
                loginData
                  ? dispatch(
                      userAddCartItemsActions(
                        i18n.language,
                        userId,
                        {
                          user_id: userId,
                          device: "web",
                          project_type: "helping_case",
                          id: data?.id,
                          duration: 0,
                          amount: formik.values.amount,
                        },
                        () => {
                          notification.success({
                            message: `${t("Added to cart")}`,
                          });

                          dispatch(
                            userGetCartItemsActions(userId, i18n.language)
                          );
                        }
                      )
                    )
                  : dispatch(
                      {
                        type: ADD_TO_CART,
                        payload: {
                          category: "humanitarian_projects",
                          project: {
                            id: data?.id,
                            amount: formik.values.amount,
                            image_url: data?.thumbnail_url,
                            title_en: data?.title_en,
                            title_ar: data?.title_ar,
                            duration: 0,
                            project_type: "humanitarian_projects",
                            device: "web",
                          },
                        },
                      },
                      notification.success({
                        message: "Added to cart",
                      })
                    );
              } else {
                notification.error({
                  message: `${t("Donation amount is required")}`,
                });
              }
            }}
          >
            <img className="min-w-[30px]" src={cartwhite} alt="" />
          </button>
        </div>

        {/* Project Details */}
        <div className="flex items-center">
          <div className="px-[15px] py-[5px] bg-white rounded-[15px] cursor-pointer border border-first_color">
            <p
              onClick={() =>
                navigate(`${HUMAN_PROJECT_DETAILS_PATH}/${data?.id}`)
              }
              className={`flex items-center gap-3 font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] text-[15px] text-first_color cursor-pointer group`}
            >
              {t("Project Details")}
              {i18n.language === "en" ? (
                <img
                  className="group-hover:animate-[moveRight_1s_ease-in-out_infinite]"
                  src={more}
                  alt=""
                />
              ) : (
                <img
                  className="group-hover:animate-[moveLeft_1s_ease-in-out_infinite]"
                  src={moreRotated}
                  alt=""
                />
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HumanitarianCasesCard;
